// src/app/formdata-upload/base64-upload.component.ts

import { AfterContentChecked, AfterContentInit, Component, ContentChild, ElementRef, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { MatSnackBar } from '@angular/material';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogoConfirmacionComponent } from '../DialogConfirmacion/dialogo-confirmacion.component';

declare var $:any;

@Component({
	selector: 'asignarPDFEscritura',
	templateUrl: './asignarPDFEscritura.component.html'
})
export class asignarPDFEscrituraComponent implements AfterContentInit{
	
	public loading: boolean = false;
	public bloquearBoton:boolean = true;
	public mensajes:Array<string> = new Array();
	public displayedColumns;
	public dataSource;
	public erroresTemp:Array<string> = new Array();
	public cnumcont: string;
	public vidEscritura: string;
	public cprefijo: string;
	public ndocumento: string;

	public ocultar: boolean = false;
	public mensaje: string = "";

	@ViewChild('fileInput') fileInput: ElementRef;
	@ViewChild('form') form;

	constructor( private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,private _route: ActivatedRoute,private _router: Router,public dialogo: MatDialog) {
		this.displayedColumns = ['mensaje'];
		this.dataSource = new ExampleDataSource(null);
		
		this.snackBar.dismiss();

		this._route.params.subscribe(params => {
			this.cnumcont = params['cnumcont'];
			this.vidEscritura = params['vidEscritura'];
			this.cprefijo = params['cprefijo'];
			this.ndocumento = params['ndocumento'];

		});

	}

	private formulario:any;


	ngAfterContentInit() {
		$('#archivoLoad').on("change", function(){ 
			
			$('#uploadFile').val(
				$('#archivoLoad').val().replace('C:\\fakepath\\', '')
				); 
		});
	}

	onFileChange(event) {
		let reader = new FileReader();
		if(event.target.files && event.target.files.length > 0) {
			let file = event.target.files[0];
			reader.readAsDataURL(file);
			reader.onload = () => {
				this.bloquearBoton = false;
				//console.log('Recarga');
				this.formulario ={
					nombreArchivo: file.name,
					//filetype: file.type,
					infoArchivo: reader.result.split(',')[1]
				}
			};
		}
	}

	onSubmit() {
		const formModel = this.formulario;
		this.loading = true;
		this.dataSource = new ExampleDataSource(null);
		this.erroresTemp = new Array();

		
		if(formModel == undefined || formModel.infoArchivo == undefined || formModel.infoArchivo == ''){
			this.openSnackBarEspecial("Hay que seleccionar un archivo", "X");
			this.loading = false;
			return;	
		}

		if(this.formulario.nombreArchivo.toLowerCase().indexOf('.pdf')==-1){
			this.openSnackBarEspecial("Esta opción solo permite cargue de archivos tipo PDF. Cargue no realizado", "X");
			this.loading = false;
			return;
		}

		if(this.formulario.nombreArchivo.includes(",")){
			this.openSnackBarEspecial("Nombre de archivo invalido, no debe contener caracteres especiales", "X");
			this.loading = false;
			return;
		}

		if(this.ndocumento =='1'){
		
			var ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa 
		
			this._serviciosGenerales.post('consultarArchivoMongoEscritura/Escritura/CNUMCONT='+this.cnumcont+
			'&CPREFIJO='+this.cprefijo+
			'&VID_ESCRITURA='+this.vidEscritura+
			'&NTIPOEMPRESA='+ntipoempresa, {
			 }).subscribe(
				result => {
					if(result.info =='0'){
						this.openSnackBarEspecial("Error en el servicio, por favor contacte al administrador", "X");
						return ;
					}
					if(result.info !== undefined){
						
						this.mostrarDialogoCargarArchivo();
						
					}else{

						this.realizarCargueArchivo();
						
					}
				},
				error => {
					var errorMensaje = <any>error;
					//console.log('Error al enviar la peticion ', errorMensaje);
				});	

		}	
		else{
			this.realizarCargueArchivo();
		}
	}


	mostrarDialogoCargarArchivo(): void {
		
		this.dialogo
		  .open(DialogoConfirmacionComponent, {

			data: 'Ya existe un archivo cargado para este id de escritura, desea reemplazarlo?'
		  })
		  .afterClosed()
		  .subscribe((confirmado: Boolean) => {
			if (confirmado) {
				this.realizarCargueArchivo();
			} 
			else{
				this.loading = false;
				this.openSnackBar("Cargue no realizado", "X");
			}
		  });
		
	}


	realizarCargueArchivo(){
		const formModel = this.formulario;
		var ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa 
		var usuario = this._serviciosGenerales.seguridad.getInfoSesion().usuario;
		
		var parametros = "{ CNUMCONT:'"+this.cnumcont+"', CPREFIJO:'"+this.cprefijo+"' ,VIDESCRITURA:'"+this.vidEscritura+"',NTIPOEMPRESA:'"+ntipoempresa+"',USUARIO:'"+usuario+"', TIPODOCUMENTO:'ESCRITURA'"+"}";

		this._serviciosGenerales.post('cargueGenericoPDF/'+parametros, formModel).subscribe(
			result=>{
				this.formulario ={}
				console.log(result);
				$("#archivoLoad").val(null);
				$("#uploadFile").val('');

				if(result.error == true){
					if(result.mensajes != undefined){

						for(let x in result.mensajes){
							this.erroresTemp.push(result.mensajes[x].mensaje)
						}
						this.dataSource = new ExampleDataSource(this.erroresTemp);
					}if(result.errores){
						for(let x in result.errores){
							this.erroresTemp.push(result.errores[x])
						}
						this.dataSource = new ExampleDataSource(this.erroresTemp);
					}else{
						this.openSnackBar(result.mensaje, "X");
						this._router.navigate(['/Escritura', this.cnumcont, this.cprefijo]);
					}	
				}
				else {
					this.openSnackBar(result.mensaje, "X");
				}
				this.loading = false;

			},error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este cargue", "X");
				this.loading = false;
				$("#archivoLoad").val(null);
			})

	}


	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			//console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}



export class ExampleDataSource {

	public data: Array<string>;


	constructor(sucursal:Array<string>){
		this.data = new Array();


		if(sucursal != null){
			for(let i of sucursal){
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<string[]>
	{
		return Observable.of(this.data);
	}

	disconnect()
	{
	}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearEscritura/asignarPDFEscritura.component.ts